<template>
  <v-app-bar
    id="app-bar"
    absolute
    app
    color="transparent"
    flat
    height="75"
  >
    <v-btn
      class="mr-3"
      elevation="1"
      fab
      small
      @click="setDrawer(!drawer)"
    >
      <v-icon v-if="value">
        mdi-view-quilt
      </v-icon>

      <v-icon v-else>
        mdi-dots-vertical
      </v-icon>
    </v-btn>

    <v-toolbar-title
      class="font-weight-light ms-3"
      v-text="this.$t($route.name)"
    />

    <v-spacer />

<!--    <v-text-field-->
<!--      :label="$t('search')"-->
<!--      color="secondary"-->
<!--      hide-details-->
<!--      style="max-width: 165px;"-->
<!--    >-->
<!--      <template-->
<!--        v-if="$vuetify.breakpoint.mdAndUp"-->
<!--        v-slot:append-outer-->
<!--      >-->
<!--        <v-btn-->
<!--          class="mt-n2"-->
<!--          elevation="1"-->
<!--          fab-->
<!--          small-->
<!--        >-->
<!--          <v-icon>mdi-magnify</v-icon>-->
<!--        </v-btn>-->
<!--      </template>-->
<!--    </v-text-field>-->

    <div class="mx-3" />

    <v-menu
      bottom
      right
      offset-y
      origin="top left"
      transition="scale-transition"
    >
      <template v-slot:activator="{ attrs, on }">
        <v-btn
          class="ml-2"
          min-width="0"
          text
          v-bind="attrs"
          v-on="on"
        >
          <v-badge
            color="red"
            overlap
            bordered
          >
            <template v-slot:badge>
              <span>5</span>
            </template>
            <i class="fad fa-bell-on fa-2x" />
          </v-badge>
        </v-btn>
      </template>

      <v-list
        :tile="false"
        nav
      >
        <div>
          <app-bar-item
            v-for="(n, i) in notifications"
            :key="`item-${i}`"
          >
            <v-list-item-title v-text="n" />
          </app-bar-item>
        </div>
      </v-list>
    </v-menu>

    <v-menu
      bottom
      right
      offset-y
      origin="top left"
      transition="scale-transition"
    >
      <template v-slot:activator="{ attrs, on }">
        <v-btn
          class="ml-2"
          min-width="0"
          text
          v-bind="attrs"
          v-on="on"
        >
          <i class="fad fa-user-tie fa-2x" />
        </v-btn>
      </template>

      <v-list
        dense
      >
        <v-list-item>
          <i class="fad fa-user-cog fa-fw fa-lg me-3" />
          <v-list-item-title v-text="this.$t('profile')" />
        </v-list-item>
        <v-list-item @click="logout">
          <i class="fad fa-power-off fa-fw fa-lg me-3" />
          <v-list-item-title v-text="this.$t('logout')" />
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
  // Components
  import { VHover, VListItem } from 'vuetify/lib'

  // Utilities
  import { mapState, mapMutations } from 'vuex'

  export default {
    name: 'DashboardCoreAppBar',

    components: {
      AppBarItem: {
        render (h) {
          return h(VHover, {
            scopedSlots: {
              default: ({ hover }) => {
                return h(VListItem, {
                  attrs: this.$attrs,
                  class: {
                    'black--text': !hover,
                    'white--text secondary elevation-12': hover,
                  },
                  props: {
                    activeClass: '',
                    dark: hover,
                    link: true,
                    ...this.$attrs,
                  },
                }, this.$slots.default)
              },
            },
          })
        },
      },
    },

    props: {
      value: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      notifications: [
        'Mike John Responded to your email',
        'You have 5 new tasks',
        'You\'re now friends with Andrew',
        'Another Notification',
        'Another one',
      ],
    }),

    computed: {
      ...mapState(['drawer']),
    },

    methods: {
      ...mapMutations({
        setDrawer: 'SET_DRAWER',
      }),
      logout () {
        this.$session.destroy()
        this.$router.push('/login')
      },
    },
  }
</script>
